import { axios, base } from '../http';

export const getRepairFaultTypeList = (params) =>
  axios.get(`${base}/api/RepairFaultType/Get`, { params });
/** 新增故障类型 */

export const addRepairFaultType = (params) =>
  axios.post(`${base}/api/RepairFaultType/Post`, params);
/** 编辑故障类型 */

export const editRepairFaultType = (params) =>
  axios.put(`${base}/api/RepairFaultType/Put`, params);
/** 删除故障类型 */

export const deleteRepairFaultType = (id) =>
  axios.delete(`${base}/api/RepairFaultType/Delete`, { params: { id } });
/** 初始化默认故障类型 */

export const initRepairFaultTypeDefaults = (departmentId) =>
  axios.post(`${base}/api/RepairFaultType/InitDefaults`, null, { params: { departmentId } });

// ─── 报修单管理（PC） ──────────────────────────────────────────────
/** 分页查询报修单列表 */

export const getRepairRequestListPage = (params) =>
  axios.get(`${base}/api/RepairRequest/Get`, { params });
/** 导出报修单列表（Excel） */

export const exportRepairRequestList = (params) =>
  axios.get(`${base}/api/RepairRequest/Export`, { params, responseType: 'blob' });
/** 导出单张报修单 PDF */
export const exportRepairRequestPdf = (id) =>
  axios.get(`${base}/api/RepairRequest/ExportPdf`, { params: { id }, responseType: 'blob', timeout: 120000 });
/** 获取报修单详情 */

export const getRepairRequestDetail = (id) =>
  axios.get(`${base}/api/RepairRequest/GetDetail`, { params: { id } });
/** 手动指派维修师傅（故障类型未绑定师傅时由管理员操作） */

export const manualDispatchRepair = (params) =>
  axios.post(`${base}/api/RepairRequest/ManualDispatch`, params);

/** 上传维修过程图片（PC 管理员） */
export const uploadRepairProcessMedia = (params) =>
  axios.post(`${base}/api/RepairRequest/UploadProcessMedia`, params);

export const getRepairStatistics = (params) =>
  axios.get(`${base}/api/RepairRequest/GetStatistics`, { params });

export const exportRepairStatistics = (params) =>
  axios.get(`${base}/api/RepairRequest/ExportStatistics`, { params, responseType: 'blob' });

/** 获取报修流程模式配置 */
export const getRepairSchoolConfig = (params) =>
  axios.get(`${base}/api/RepairSchoolConfig/Get`, { params });

/** 保存报修流程模式配置 */
export const setRepairSchoolConfig = (params) =>
  axios.post(`${base}/api/RepairSchoolConfig/Set`, params);

// ── 报修管理员 ──────────────────────────────────────────────────────────────
/** 分页获取报修管理员列表 */

export const getRepairAdminListPage = (params) =>
  axios.get(`${base}/api/RepairAdmin/GetList`, { params });
/** 获取已启用的报修管理员（TeacherMaster 列表，供鉴权/选人） */

export const getRepairAdminsForSelect = (params) =>
  axios.get(`${base}/api/RepairAdmin/GetRepairAdmins`, { params });
/** 新增报修管理员 */

export const addRepairAdmin = (params) =>
  axios.post(`${base}/api/RepairAdmin/Add`, params);
/** 编辑报修管理员 */

export const editRepairAdmin = (params) =>
  axios.post(`${base}/api/RepairAdmin/Edit`, params);
/** 删除报修管理员 */

export const removeRepairAdmin = (params) =>
  axios.post(`${base}/api/RepairAdmin/Delete`, null, { params });

// ── 智能会议室 ──────────────────────────────────────────────────────────────
